import { useNavigate } from "react-router-dom";
import { User, FileText, CalendarCheck, Users, ShieldCheck, Info, LogOut, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { useAuthStore } from "@/store/authStore";

export default function More() {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  const ITEMS = [
    { id: "profile", label: "My Profile", icon: User, color: "#2563EB", onClick: () => navigate("/profile") },
    { id: "records", label: "Health Records", icon: FileText, color: "#EC4899", onClick: () => navigate("/records") },
    { id: "bookings", label: "My Bookings", icon: CalendarCheck, color: "#16A34A", onClick: () => navigate("/for-you") },
    { id: "family", label: "Family Members", icon: Users, color: "#F59E0B", onClick: () => navigate("/profile") },
    { id: "privacy", label: "Privacy & Consent (DPDP)", icon: ShieldCheck, color: "#005C66", onClick: () => navigate("/consent") },
    { id: "about", label: "About Trata Health", icon: Info, color: "#7C3AED", onClick: () => toast.info("Trata Health — The Missing Link in your healthcare.") },
  ];

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <h1 className="text-2xl md:text-3xl font-semibold">More</h1>
      <Card className="rounded-3xl overflow-hidden divide-y divide-border">
        {ITEMS.map((it) => (
          <button key={it.id} onClick={it.onClick} className="w-full flex items-center gap-3 px-4 py-4 hover:bg-accent transition-colors text-left" data-testid={`more-${it.id}`}>
            <div className="h-9 w-9 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: it.color + "1A" }}>
              <it.icon className="h-4 w-4" style={{ color: it.color }} />
            </div>
            <span className="flex-1 text-sm font-medium">{it.label}</span>
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
          </button>
        ))}
      </Card>
      <button onClick={handleLogout} className="w-full flex items-center justify-center gap-2 h-12 rounded-2xl border border-destructive/30 text-destructive font-medium" data-testid="more-logout">
        <LogOut className="h-4 w-4" /> Log out
      </button>
    </div>
  );
}
